import React, { useState, useEffect } from 'react'

import i18n from 'live/services/i18n'
import TableForm from 'live/components/forms/ui/TableForm'

const fields = [
    {
        name: 'topic',
        label: i18n('Topic'),
        type: 'text'
    },
    {
        name: 'qos',
        label: i18n('QoS'),
        type: 'number'
    },
    {
        name: 'eventType',
        label: i18n('Event type'),
        type: 'text'
    }
]

export type TopicManagementFormProps = {
    caller: any
    dataObject: object
}

export type TopicConfig = {
    topic: string
    qos: number
    eventType: string
}

export type TopicDataResult = {
    errMsg: string | null
    data: object | null
}

const TopicManagementForm: React.FC<TopicManagementFormProps> = ({ caller, dataObject }: TopicManagementFormProps) => {
    const [data, setData] = useState([])
    const [errorMsg, setErrorMsg] = useState('')

    useEffect(() => {
        setData(fromData(dataObject))
    }, [dataObject])

    // Appends {key, value} to data. Return null if key is empty or key exists
    // dest: object array, src: array => object
    function toData(src: Array<TopicConfig>): TopicDataResult {
        const dest = new Array<TopicConfig>()
        const topicDataResult: TopicDataResult = {
            errMsg: null,
            data: null
        }

        src.forEach((entry, index) => {
            const currentLine = index + 1

            const topic = entry.topic.trim()
            if (topic.length === 0) {
                topicDataResult.errMsg = i18n('Empty_Topic', { line: currentLine })

                return topicDataResult
            }

            if (dest.some(t => t.topic === topic)) {
                topicDataResult.errMsg = i18n('Topic_Exists', { topic: topic, line: currentLine })

                return topicDataResult
            }

            const qos = Number(entry.qos ?? 1)
            if (qos > 2 || qos < 0) {
                topicDataResult.errMsg = i18n('Invalid_QoS', { topic: topic, line: currentLine })

                return topicDataResult
            }

            const eventType = entry.eventType.trim()
            if (eventType.length === 0) {
                topicDataResult.errMsg = i18n('Empty_EventType', { topic: topic, line: currentLine })

                return topicDataResult
            }

            dest.push(entry)
        })

        topicDataResult.data = dest

        return topicDataResult
    }

    // From service. It MUST be validated
    // JSON object to JSON array
    function fromData(data: any): any {
        const list = []
        const type = typeof data

        if (type !== 'object') setErrorMsg(i18n('Unable_Parse', { valueType: type }))

        if (Array.isArray(data)) {
            data.forEach((config: any) => {
                const valueType = typeof config
                if (valueType === 'object') {
                    list.push({
                        topic: config.topic,
                        qos: Number(config.qos),
                        eventType: config.eventType
                    })
                } else {
                    setErrorMsg(i18n('Wrong_Schema', { valueType: valueType }))

                    return []
                }
            })
        }

        return list
    }

    function onChangeObject(e: any) {
        setData(e)
        const result: TopicDataResult = toData(e)
        caller(result)

        if (result.errMsg == null) setErrorMsg('')
        else setErrorMsg(result.errMsg)
    }

    return (
        <div>
            <TableForm
                data={data}
                fields={fields}
                onChange={(e: any) => {
                    onChangeObject(e)
                }}
            />
            <p style={{ color: 'red' }}>{errorMsg}</p>
        </div>
    )
}

export default TopicManagementForm
